{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".point_Slider");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          // autoplay: {
          //   delay: 1000,
          //   disableOnInteraction: false,
          // },
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 1.5,
              spaceBetween: 20,
            },
            769: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".Testimonails_Slider");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          loop: false,
          speed: 1000,
          // autoplay: {
          //   delay: 1000,
          //   disableOnInteraction: false,
          // },
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 1.5,
              spaceBetween: 20,
            },
            769: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
  const MultipleSlider = () => {
    const MultipleSliders = document.querySelectorAll(".reviews__slider");
    MultipleSliders.forEach((slider, index) => {
      const prevArrow = slider.parentElement.querySelector(".prev");
      const nextArrow = slider.parentElement.querySelector(".next");
      const slides = slider.querySelectorAll(".swiper-slide");
      const totalSlides = slides.length;
      const cloneMultiplier = parseInt(slider.dataset.cloneMultiplier, 10) || 2;
      for (let i = 0; i < cloneMultiplier; i++) {
        slides.forEach((slide) => {
          const clone = slide.cloneNode(true);
          slider.querySelector(".swiper-wrapper").appendChild(clone);
        });
      }
      console.log(
        `Slider #${index + 1}: original ${totalSlides} slides, cloned ${cloneMultiplier}x, total ${
          slider.querySelectorAll(".swiper-slide").length
        } slides.`
      );
      new Swiper(slider, {
        direction: "horizontal",
        loop: true,
        speed: 4000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        centeredSlides: true,
        grab:true,
        navigation: {
          nextEl: nextArrow,
          prevEl: prevArrow,
        },
        breakpoints: {
          150: {
            slidesPerView: 1.2,
            spaceBetween: 10,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          769: {
            slidesPerView: 2.6,
            spaceBetween: 20,
          },
          1025: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      });
    });
  };

  MultipleSlider();
});

}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".testimonails-slide");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          loop: true,
          speed: 1000,
          grabCursor: true,
          // autoplay: {
          //   delay: 5000,
          //   disableOnInteraction: false,
          // },
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}